import { makeSchedulable, SchedulablesController } from "./schedulable_helpers";

export default makeSchedulable(class extends SchedulablesController {
  static targets = ["detailsList", "detailsListContent"];

  connect() {
    this.closeSlideOut = this.closeSlideOut.bind(this);
    App.Helpers.listenToCustomEvent(document, "schedulables:delete-success", this.closeSlideOut)
  }

  closeSlideOut({ detail }) {
    const { schedulableID, schedulableType } = detail;
    if (this.schedulableID == schedulableID && this.schedulableType == schedulableType) {
      App.SlideOut.close({ element: this.element })
    }
  }
});



// WEBPACK FOOTER //
// ./app/components/schedulables/assets/javascript/schedulables-show-controller.js